import React, { memo, useState } from 'react'

import { GameInfoPopup } from '../game-info-popup'
import Iconify from '../../../../components/Iconify'

import {
  ActionButton,
  ActionButtons,
  BackgroundImage,
  BlurredBackgroundImage,
  BottomGradient,
  Card,
  ExclusiveBadge,
  HotBadge,
  HoverOverlay,
  InfoWrapper,
  RankNumber,
  ShineContainer,
  ShineSweep,
  TopLeftBadges,
} from './card-top.styled'

const noop = () => {}

export const CardTop = memo(function CardTop({
  numer,
  number,
  displayNumber,
  game,
  onLaunchGame,
  onClick,
  size = 'lg',
  featured,
  compactAspect = false,
  instant = false,
  hoverScale = 1.05,
}) {
  const [isHovered, setIsHovered] = useState(false)
  const rank = numer ?? number ?? game?.rank
  const isHotGame = Number.isFinite(Number(rank)) && Number(rank) < 11
  const hasDemo = Boolean(game?.has_demo)
  const rankLift = size === 'sm' ? -8 : -30

  const handleClick = () => {
    if (onLaunchGame) {
      onLaunchGame(false)
      return
    }

    if (onClick) {
      onClick(game)
    }
  }

  const handlePlay = (event) => {
    event.stopPropagation()
    if (onLaunchGame) {
      onLaunchGame(false)
    }
  }

  const handleDemo = (event) => {
    event.stopPropagation()
    if (onLaunchGame) {
      onLaunchGame(true)
    }
  }

  return (
    <Card
      $size={size}
      $compactAspect={compactAspect}
      $clickable={Boolean(onClick || onLaunchGame)}
      onClick={handleClick}
      initial={instant ? false : { opacity: 0, borderColor: '#1e1e1e00' }}
      animate={instant ? false : { opacity: 1, borderColor: '#1e1e1e' }}
      transition={instant ? undefined : { delay: 0.2 }}
      whileHover={{
        ...(hoverScale !== 1 ? { scale: hoverScale } : {}),
        zIndex: 20,
        borderColor: '#ffffff',
        boxShadow: '0 10px 24px rgba(0, 0, 0, 0.45)',
        transition: {
          type: 'spring',
          stiffness: 300,
          damping: 20,
        },
      }}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
    >
      <ShineContainer>
        <ShineSweep
          animate={
            isHovered
              ? { x: '160%', y: '50%', rotate: 45 }
              : { x: '-120%', rotate: 45, y: '-120%' }
          }
          transition={{ ease: 'easeOut' }}
        />
      </ShineContainer>
      {!compactAspect ? (
        <BlurredBackgroundImage
          src={game.thumbnail}
          alt=''
          aria-hidden='true'
          loading='lazy'
        />
      ) : null}
      <BackgroundImage
        $compactAspect={compactAspect}
        src={game.thumbnail}
        alt={game.name}
        loading='lazy'
      />
      <BottomGradient aria-hidden='true' />
      {isHotGame || featured?.trim() ? (
        <TopLeftBadges $size={size}>
          {isHotGame ? (
            <HotBadge $size={size}>
              <Iconify icon='solar:fire-bold' />
            </HotBadge>
          ) : null}
          {featured?.trim() ? <ExclusiveBadge $size={size}>{featured}</ExclusiveBadge> : null}
        </TopLeftBadges>
      ) : null}
      <HoverOverlay $visible={isHovered}>
        <ActionButtons $size={size}>
          <ActionButton
            type='button'
            $size={size}
            $compactAspect={compactAspect}
            $fullWidth={!hasDemo}
            aria-label={`Jugar ${game.name}`}
            onClick={handlePlay}
          >
            <Iconify icon='stash:play-solid' width={25} height={25} />
          </ActionButton>
          {hasDemo ? (
            <ActionButton
              type='button'
              $size={size}
              $compactAspect={compactAspect}
              $fullWidth={false}
              aria-label={`Demo de ${game.name}`}
              onClick={handleDemo}
            >
              DEMO
            </ActionButton>
          ) : null}
        </ActionButtons>
      </HoverOverlay>
      <InfoWrapper onClick={(event) => event.stopPropagation()}>
        <GameInfoPopup game={game} onLaunchGameClicked={onLaunchGame || noop} />
      </InfoWrapper>
      {displayNumber ? (
        <RankNumber
          $size={size}
          aria-hidden='true'
          initial={{ x: '-50%', y: 0 }}
          animate={{ x: '-50%', y: isHovered ? rankLift : 0 }}
          transition={{
            type: 'spring',
            stiffness: 300,
            damping: 20,
          }}
        >
          {rank}
        </RankNumber>
      ) : null}
    </Card>
  )
})
